import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type { Ref } from 'react';
import type { CompareAnalytics } from '../../OfferContext';
import { ProductCardApplyNow } from '../components/ApplyNow';
import { ProductCardCardAndTitle } from '../components/CardAndTitle';
type DesktopProps = {
  innerRef: Ref<HTMLDivElement>;
  updatedAnalytics: Partial<CompareAnalytics>;
};
export function Desktop(t0) {
  const $ = _c(11);
  const {
    innerRef,
    updatedAnalytics
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      sx: {
        display: {
          xs: "none",
          md: "block"
        }
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== innerRef || $[2] !== updatedAnalytics) {
    t2 = <ProductCardCardAndTitle key="ProductCardCardAndTitle-Desktop" ref={innerRef} analyticsProps={updatedAnalytics} additionalContainerProps={t1} />;
    $[1] = innerRef;
    $[2] = updatedAnalytics;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      mt: 2
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      padding: 0,
      display: {
        xs: "none",
        md: "block"
      }
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== updatedAnalytics) {
    t5 = <Box sx={t3}><ProductCardApplyNow containerProps={t4} analyticsProps={updatedAnalytics} needsFixedHeight={true} /></Box>;
    $[6] = updatedAnalytics;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}